export const navigateTo = (navigate, path, isAllowed) => {
  const currentLanguage = localStorage.getItem("language") || "am";
  navigate(`/${currentLanguage}${path}`);
};
